'use strict';

const getOffset = element => {
  const { top, left } = element.getBoundingClientRect();
  return {
    top: top + window.pageYOffset - document.body.clientTop,
    left: left + window.pageXOffset - document.body.clientLeft,
  };
};

module.exports = getOffset;
